import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

//scss
import "./Topbar.scoped.scss";

// hooks and utilities
import { useLanguage } from "lang/Translate";
import useTab from "hooks/useTab";
import useRedirect from "hooks/useRedirect";

// common components
import BallPulseLoader from "components/common/BallPulseLoader/BallPulseLoader";

// redux
import { toggleWindowSidebar } from "redux/actions/WindowReducerActions";

// assets
import Select from "components/common/Select/Select";

const Topbar = ({ navEnabled, topbarEnabled }) => {
	const currentAddress = useSelector(state => state.window.currentAddress).split(".");
	const currentSidebarTab = useTab("", true);
	// const currentTopBarTabId = useTab("*");
	const redirect = useRedirect();
	const dispatch = useDispatch();

	const __THEME__ = process.env.__THEME__;

	const changeSubtab = id => {
		redirect(currentAddress[0].concat(".", id), null);

		// if (currentTopBarTabId === id && currentAddress.length > 2) {
		// 	const newAddress = currentAddress;
		// 	newAddress.pop();

		// 	if (searchForTab(tabs, newAddress[newAddress.length - 1]).needsSubTab) return;
		// 	redirect(newAddress.join("."), null);
		// 	return;
		// }

		// TODO: remove this --> all nav visibility changes will have to be defined in tabs.json
		!navEnabled && dispatch(toggleWindowSidebar());
	};

	return (
		<div
			className={`topbar ${__THEME__ === "retro" && "retro"} rajdhani ${!navEnabled &&
				"topbar--full"} ${!topbarEnabled && "hide"}`}
		>
			{window.innerWidth > 750 ? (
				<TextTabs tabsToDisplay={currentSidebarTab?.subTabs || []} changeSubtab={changeSubtab} />
			) : (
				<Dropdown tabsToDisplay={currentSidebarTab?.subTabs || []} changeSubtab={changeSubtab} />
			)}

			<div className="close" onClick={() => redirect("")}>
				<i className="fas fa-long-arrow-alt-right" />
			</div>
		</div>
	);
};

const TextTabs = ({ tabsToDisplay, changeSubtab }) => {
	const currentTopBarTabId = useTab("*");
	const currentLanguage = useLanguage();

	return (
		<div className="container">
			{tabsToDisplay.map(({ id, name: [pl, en] }, i) => (
				<p
					className={`item ${currentTopBarTabId === id && "item--active"}`}
					key={i}
					onClick={() => changeSubtab(id)}
				>
					{currentLanguage === "PL" ? pl : en}
				</p>
			))}
		</div>
	);
};

const Dropdown = ({ tabsToDisplay, changeSubtab }) => {
	const parentTab = useTab("");
	const currentTopBarTabId = useTab("*");
	const currentLanguage = useLanguage();
	const [options, setOptions] = useState([]);
	const [selectedOption, setSelectedOption] = useState({});

	useEffect(() => {
		setOptions(
			tabsToDisplay.map(({ id, name: [pl, en] }) => ({
				value: id,
				label: currentLanguage === "PL" ? pl : en
			}))
		);
	}, [tabsToDisplay, currentLanguage]);

	useEffect(() => {
		setSelectedOption(options.find(o => o.value === currentTopBarTabId));
	}, [options, currentTopBarTabId]);

	if (options.length <= 1 || parentTab === "fuelIcon") return null;
	return (
		<Select
			options={options}
			value={selectedOption}
			placeholder={selectedOption?.label || <BallPulseLoader center={true} />}
			onChange={({ value: id }) => changeSubtab(id)}
			transparent={true}
			isSearchable={false}
		/>
	);
};

export default Topbar;
